const ProfileKey = 'Admin-Profile';

export function showProfile() {
  try {
    const raw = localStorage.getItem(ProfileKey);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function updateProfile(token) {
  return localStorage.setItem(ProfileKey, JSON.stringify(token));
}
